// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"7776777f","150":"dd3e5478","182":"97fa38bc","311":"80526bc1","332":"821ee280","410":"30c16e62","705":"f9156542"}[chunkId] + ".chunk.js";
};